import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import "semantic-ui-css/semantic.min.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import "./assets/style/style.scss";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
  <BrowserRouter>    
      <App />   
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
